import { useOnNewNotificationSubscription } from '@sit/graphql';
import { useIsAuthenticated } from '@web/redux/hooks';

export function useLatestServerNotification() {
  const isAuthenticated = useIsAuthenticated();
  return useOnNewNotificationSubscription({ skip: !isAuthenticated });
}
